<template>
  <v-select
    v-bind="$attrs"
    v-model="internalValue"
    :items="items"
    :color="primaryColor"
    persistent-hint
    :item-value="itemValue"
    :hint="selectedAccountHint"
    :return-object="isReturnObject"
   data-qa="listaccountsselect-select-5b3t6d">
    <template v-slot:selection="data">
      <span class="mt-3 mb-2" data-qa="listaccountsselect-span-49j93">
        {{ isExternal ? data.item.name : formatSelectedAccount(data.item) }}
      </span>
    </template>
    <template v-slot:item="data">
      <v-list-item-content data-qa="listaccountsselect-list-item-content-2jzzh">
          {{ isExternal ? data.item.name :  formatPrimaryLine(data.item) }}
        <v-list-item-subtitle data-qa="listaccountsselect-list-item-subtitle-qp4s8k"  v-text="getSecondaryLine(data.item)" />
        <v-divider data-qa="listaccountsselect-divider-703ye"  />
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
import { formatPrimaryLine, formatSecondaryLine, formatSelectedAccount, formatSelectedHint } from '../../../util/accountUtil'

export default {
  name: 'ListAccountsSelect',
  props: {
    value: {
      type: [String, Object, null],
      default: null
    },
    items: {
      type: Array,
      required: true
    },
    external: {
      type: Boolean,
      default: undefined
    },
    returnObject: {
      type: Boolean,
      default: undefined
    }
  },
  inheritAttrs: false, // Prevent automatic inheritance of attributes
  computed: {
    internalValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    isExternal () {
      return this.external === undefined ? false : this.external
    },
    isReturnObject () {
      return this.returnObject === undefined ? false : this.returnObject
    },
    selectedAccount () {
      if (this.isReturnObject) return this.internalValue
      if (this.isExternal) return this.items?.find(i => i.accountIdentification === this.internalValue)
      return this.items?.find(i => i.accountId === this.internalValue)
    },
    selectedAccountHint () {
      if (!this.internalValue) return ''
      if (this.isExternal) {
        return `${this.selectedAccount.accountIdentification} - ${this.selectedAccount.bankIdentifier}`
      }
      return formatSelectedHint(this.selectedAccount)
    },
    itemValue () {
      return this.isExternal ? 'accountIdentification' : 'accountId'
    }
  },
  methods: {
    formatPrimaryLine,
    formatSelectedAccount,
    formatSelectedHint,
    getSecondaryLine (item) {
      return this.isExternal ? `${item.accountIdentification} - ${item.bankIdentifier}` : formatSecondaryLine(item)
    }
  }
}
</script>
